<template>
    <div>
        <h2 class="display-serif">Enrich your profile</h2>
        <p class="body-small text-valence-grey-750 mt-1">The more context you share, the smarter your insights.</p>
    </div>
</template>
